import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { order: { getOrders } } = apiUrls

export const ORDER_SUCCESS = 'ORDER_SUCCESS';
export const ORDER_LOADING = 'ORDER_LOADING';
export const TABLE_LOADING = 'TABLE_LOADING';

export const getOrdersData = ({ amazonOrderId, name,
    sku, productName, page, pageSize, vendor }) => async (dispatch) => {

        try {
            if (vendor) {
                const requestData = {
                    ...getOrders,
                    data: {
                        amazonOrderId,
                        name,
                        sku,
                        productName,
                        page,
                        pageSize
                    }
                };
                const data = await REQUEST(requestData);
                dispatch({
                    type: ORDER_SUCCESS,
                    data,
                    vendor
                })
            }

        } catch (e) {

            dispatch({
                type: ORDER_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                },
                vendor
            })
        }
    }

export const handleLoader = (isLoading, vendor) => (dispatch) => {
    if (vendor) {
        dispatch({
            type: ORDER_LOADING,
            isLoading,
            vendor
        });
    }
}


export const handleTableLoader = (isTableLoading, vendor) => (dispatch) => {
    if (vendor) {
        dispatch({
            type: TABLE_LOADING,
            isTableLoading,
            vendor
        });
    }
}



